import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import { TextFieldCustomProps } from './WeightInputField';

const useStyles = makeStyles({
  quantityInputContainer: {
    '& input': {
      textAlign: 'right',
    },
  },
});

interface PercentageFormatCustomProps extends NumberFormatProps {
  inputRef: (instance: NumberFormat<any> | null) => void;
  onChange?: (value: any) => void;
  name: string;
  decimalScale?: number;
  allowNegative?: boolean;
}

const PercentageInputFormat = (props: PercentageFormatCustomProps) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange?.(values.value);
      }}
      decimalSeparator=","
      fixedDecimalScale={props.fixedDecimalScale ?? true}
      decimalScale={props.decimalScale ?? 4}
      isNumericString
      allowNegative={props.allowNegative ?? false}
      suffix=" %"
    />
  );
};

const PercentageInputField: React.FC<TextFieldCustomProps> = ({
  InputProps,
  fixedDecimalScale,
  decimalScale,
  ...rest
}) => {
  const classes = useStyles();
  const inputProps = InputProps ? InputProps.inputProps : {};

  return (
    <TextField
      variant="outlined"
      InputProps={{
        ...InputProps,
        inputComponent: PercentageInputFormat as any,
        inputProps: { fixedDecimalScale, decimalScale, ...inputProps },
      }}
      className={classes.quantityInputContainer}
      {...rest}
    />
  );
};

export default PercentageInputField;
